<template>
  <div class="page-container">
    <md-app class="full-height" md-mode="fixed">
      <!-- 
   /$$                         /$$
  | $$                        | $$
 /$$$$$$    /$$$$$$   /$$$$$$ | $$
|_  $$_/   /$$__  $$ /$$__  $$| $$
  | $$    | $$  \ $$| $$  \ $$| $$
  | $$ /$$| $$  | $$| $$  | $$| $$
  |  $$$$/|  $$$$$$/|  $$$$$$/| $$
   \___/   \______/  \______/ |__/
-->

      <!-- menu item and brand   -->
      <md-app-toolbar class="md-plain">
        <md-button
          class="md-icon-button brand-toolbar"
          @click="toggleMenu"
          v-if="!menuVisible"
        >
          <md-icon>menu</md-icon>
        </md-button>
        <router-link v-bind:to="'/naniungo'" @click.native="scrollToTop" exact>
          <a v-if="!menuVisible">
            <img
              style="width: 100px; margin: 3px"
              src="./assets/naniungo_schriftzug.png"
            />
          </a>
        </router-link>
        <span class="header-cta md-xsmall-hide">
          <!-- application form dialog   -->
          <md-dialog :md-active.sync="showDialog">
            <md-dialog-content>
              <span
                style="position: absolute; top: 20px; right: 0px; -index: 1000"
              >
                <md-button @click="showDialog = false" class="md-button-icon">
                  <md-icon>clear</md-icon>
                </md-button>
              </span>
              <application-form
                @close-dialog="closeDialog"
                @user-saved="userSavedSnackbar"
              ></application-form>
            </md-dialog-content>
          </md-dialog>

          <!-- inquiry form dialog - cart -->
          <md-dialog :md-active.sync="showCart">
            <md-dialog-content>
              <span
                style="position: absolute; top: 0px; right: 0px; z-index: 1000"
              >
                <md-button @click="showCart = false" class="md-button-icon">
                  <md-icon>clear</md-icon>
                </md-button>
              </span>
              <div class="header-team" style="z-index: 1000">
                <div class="md-title">Kandidaten für Ihr Team</div>
                <div style="border-bottom: 1px solid white; heigth: 20px"></div>
                <span v-if="getCartAmount() == '0'">
                  <br />
                  <span
                    >Sie haben noch keine Favoriten
                    <br />
                    Jetzt Experten entdecken</span
                  >
                  <span v-for="navlink in navForm" :key="navlink.name">
                    <router-link
                      @click.native="closeCart()"
                      style="width: 100%"
                      v-bind:to="'/' + navlink.route"
                      exact
                    >
                      <span class="md-list-item-text">
                        <h3>
                          {{ navlink.name }}
                          <md-icon class="md-list-item-text-after-form">
                            keyboard_arrow_right
                          </md-icon>
                        </h3>
                      </span>
                    </router-link>
                  </span>
                </span>
                <br />
                <div v-for="(can, index) in cart" :key="index">
                  <span v-if="can.addtoCart"
                    >Kandidaten-ID {{ can.carerix_id }}
                    <button
                      style="background-color: $secondary-color; color: red"
                      @click="removeFromCart(can.carerix_id)"
                    >
                      x
                    </button>
                  </span>
                </div>
              </div>
              <inquiry-form
                @close-cart="closeCart"
                @message-sent="messageSentSnackbar"
                @empty-cart="emptyCart"
              ></inquiry-form>
            </md-dialog-content>
          </md-dialog>
          <md-snackbar :md-active.sync="userSaved"
            >Liebe/r {{ lastUser }}, wir haben Ihre Bewerbung
            erhalten</md-snackbar
          >
          <md-snackbar :md-active.sync="messageSent"
            >Liebe/r {{ lastUser }}, wir haben Ihre Nachricht
            erhalten</md-snackbar
          >
          <md-button class="md-raised" @click="showDialog = true"
            >Jetzt bewerben</md-button
          >
          <span v-if="value">Value: {{ value }}</span>
          <span style="padding-top: 8px">
            <md-badge :md-content="getCartAmount()">
              <md-button
                v-bind:class="{ cartadd: getCartAmount() > 0 }"
                class="md-raised"
                @click="showCart = true"
              >
                Favoriten
              </md-button>
            </md-badge>
          </span>
          <md-menu md-size="medium tool" md-align-trigger>
            <md-button
              class="md-default"
              md-menu-trigger
              style="margin-top: 5px"
            >
              <img
                style="width: 20px; margin-right: 10px"
                src="./assets/germany-flag.png"
              />0211 7817 2880
            </md-button>
            <md-menu-content>
              <img style="width: 100%" src="./assets/duesseldorf.jpg" />
              <div style="padding: 10px">
                <strong>
                  Standort: <br />
                  Düsseldorf-Medienhafen (Zentrale)
                  <br />
                  0211 – 7817 - 2880
                </strong>
              </div>
            </md-menu-content>
          </md-menu>
        </span>
        <span
          style="margin-left: 20vw"
          class="small-hide medium-hide large-hide xlarge-hide"
        >
          <md-button class="md-raised" @click="showDialog = true">
            <md-icon>email</md-icon>
          </md-button>
          <span v-if="value">Value: {{ value }}</span>
          <span style="padding-top: 8px">
            <md-badge :md-content="getCartAmount()">
              <md-button
                v-bind:class="{ cartadd: getCartAmount() > 0 }"
                class="md-raised"
                @click="showCart = true"
              >
                Favoriten
              </md-button>
            </md-badge>
          </span>
        </span>
      </md-app-toolbar>
      <md-snackbar :md-active.sync="userSaved"
        >Liebe/r {{ lastUser }}, wir haben Ihre Bewerbung erhalten</md-snackbar
      >
      <md-snackbar :md-active.sync="messageSent"
        >Liebe/r {{ lastUser }}, wir haben Ihre Nachricht erhalten</md-snackbar
      >

      <!-- 
       /$$                                                     
      | $$                                                     
  /$$$$$$$  /$$$$$$  /$$$$$$  /$$  /$$  /$$  /$$$$$$   /$$$$$$ 
 /$$__  $$ /$$__  $$|____  $$| $$ | $$ | $$ /$$__  $$ /$$__  $$
| $$  | $$| $$  \__/ /$$$$$$$| $$ | $$ | $$| $$$$$$$$| $$  \__/
| $$  | $$| $$      /$$__  $$| $$ | $$ | $$| $$_____/| $$      
|  $$$$$$$| $$     |  $$$$$$$|  $$$$$/$$$$/|  $$$$$$$| $$      
 \_______/|__/      \_______/ \_____/\___/  \_______/|__/      
-->

      <md-app-drawer
        :md-active.sync="menuVisible"
        md-persistent="full"
        class="md-scrollbar"
      >
        <md-toolbar class="md-transparent" md-elevation="0">
          <router-link style="width: 100%" v-bind:to="'naniungo'">
            <a href="/">
              <img class="main-brand" src="./assets/F-logo.png" />
            </a>
          </router-link>
          <div style="position: absolute; top: 13px; left: 9px">
            <md-button class="md-icon-button md-dense" @click="toggleMenu">
              <md-icon style="color: #cbedff">keyboard_arrow_left</md-icon>
            </md-button>
          </div>
        </md-toolbar>

        <md-list>
          <md-list-item class="top-item"> </md-list-item>
          <md-list-item v-for="tab in menuTabs" :key="tab.slug">
            <router-link
              style="width: 100%"
              v-bind:to="'/' + tab.slug"
              exact
              :title="tab.title"
            >
              <md-card md-with-hover class="md-card-nav">
                <md-card-media-cover>
                  <md-card-media md-ratio="16:9">
                    <img :src="getImg(tab.background)" alt="Skyscraper" />
                  </md-card-media>
                  <md-card-area>
                    <md-card-header>
                      <md-card-header-text>
                        <div class="md-title">{{ tab.title }}</div>
                        <div class="md-subhead menu">
                          <strong>{{ tab.subtitle1 }}</strong> <br />
                          <strong>{{ tab.subtitle2 }}</strong>
                        </div>
                      </md-card-header-text>
                    </md-card-header>

                    <md-card-actions>
                      <md-button
                        ><span class="new-profiles md-secondary"
                          ><span class="dot"></span>neue profile</span
                        ></md-button
                      >
                    </md-card-actions>
                  </md-card-area>
                </md-card-media-cover>
              </md-card>
            </router-link>
          </md-list-item>

          <!-- links -->

          <md-list-item v-for="link in links" :key="link.name">
            <router-link style="width: 100%" v-bind:to="'/' + link.route" exact>
              <span class="md-list-item-text">
                <h3>
                  {{ link.name }}
                  <md-icon class="md-list-item-text-after arrow">
                    keyboard_arrow_right
                  </md-icon>
                </h3>
              </span>
            </router-link>
          </md-list-item>
          <md-list-item> </md-list-item>
        </md-list>

        <!-- Side Footer -->
        <div
          style="position: absolute; bottom: 12px; height: 20px; width: 220px"
        >
          <div style="position: relative; top: 10px; height: 100px">
            <span class="icons" style="margin-left: 0px">
              <a
                style="font-size: 0.8rem"
                href="https://www.xing.com/companies/naniungodeutschlandgmbh"
                target="_blank"
              >
                <md-icon
                  style="margin-bottom: 9px; display: block"
                  :md-src="getSvg('xing')"
                />
              </a>
            </span>
            <span class="icons" style="margin-left: 31px">
              <a
                style="font-size: 0.8rem"
                href="https://www.linkedin.com/search/results/all/?keywords=naniungo%20Deutschland%20GmbH"
                target="_blank"
              >
                <md-icon
                  style="margin-bottom: 9px; display: block"
                  :md-src="getSvg('linkedin')"
                />
              </a>
            </span>
            <span class="icons" style="margin-left: 62px">
              <a
                style="font-size: 0.8rem"
                href="https://www.instagram.com/naniungo_deutschland_gmbh"
                target="_blank"
              >
                <md-icon
                  style="margin-bottom: 9px; display: block"
                  :md-src="getSvg('instagram')"
                />
              </a>
            </span>
            <span class="icons" style="margin-left: 93px">
              <a
                style="font-size: 0.8rem"
                href="https://www.facebook.com/naniungo"
                target="_blank"
              >
                <md-icon
                  style="margin-bottom: 9px"
                  :md-src="getSvg('facebook')"
                />
              </a>
            </span>
            <span class="icons" style="margin-left: 124px">
              <a
                style="font-size: 0.8rem"
                href="https://twitter.com/naniungo"
                target="_blank"
              >
                <md-icon
                  style="margin-bottom: 9px"
                  :md-src="getSvg('twitter')"
                />
              </a>
            </span>
            <div class="side-copy">
              <a href="/" target="_blank">© Copyright 2024 </a><br />
            </div>
            <div class="side-nan">
              <a href="/" target="_blank">naniungo® Deutschland GmbH</a><br />
            </div>
            <div class="side-imp">
              <router-link style="width: 100%" v-bind:to="'/impressum'" exact>
                <a style="font-size: 0.6rem" href="/" target="_blank">
                  Impressum
                </a>
              </router-link>
              |
              <router-link style="width: 100%" v-bind:to="'/datenschutz'" exact>
                <a style="font-size: 0.6rem" href="/" target="_blank">
                  Datenschutz
                </a>
              </router-link>
            </div>
          </div>
        </div>
      </md-app-drawer>
      <md-app-content>
        <router-view />
        <main-footer />
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { validationMixin } from "vuelidate";

import MainFooter from "./templates/Footer";
import ApplicationForm from "./templates/ApplicationForm";
import InquiryForm from "./templates/InquiryForm";

export default {
  name: "App",
  mixins: [validationMixin],
  components: {
    MainFooter,
    ApplicationForm,
    InquiryForm,
  },
  data: () => ({
    menuVisible: true,
    active: false,
    value: null,
    showDialog: false,
    showCart: false,
    showTest: false,
    firstName: "",
    lastName: "",
    jobTitle: "",
    emailAddressPrivate: "",
    phoneNumberBusiness: "",
    message: "",
    sending: false,
    userSaved: false,
    messageSent: false,
    lastUser: null,
    windowWidth: 0,
    menuTabs: [
      {
        slug: "projects",
        background: "naniungo-menu-projects.jpg",
        title: "projects",
        subtitle1: "Interim-Manager",
        subtitle2: "Freelancer",
      },
      {
        slug: "executives",
        background: "naniungo-menu-executives.jpg",
        title: "executives",
        subtitle1: "Fachkräfte",
        subtitle2: "Führungskräfte",
      },
      {
        slug: "representatives",
        background: "naniungo-menu-representatives.jpg",
        title: "representatives",
        subtitle1: "Meinungsführer",
        subtitle2: "Influencer",
      },
    ],
    links: [
      {
        name: "Home",
        route: "naniungo",
      },
      {
        name: "Über Uns",
        route: "about",
      },
      {
        name: "Themenschwerpunkte",
        route: "themen",
      },
      {
        name: "Karriere",
        route: "karriere",
      },
      {
        name: "Blog",
        route: "blog",
      },
      // {
      //   name: "Offene Stellen",
      //   route: "publications"
      // }
    ],
    navForm: [
      {
        name: "Projects - Freelancer und Interims-Manager",
        route: "projects",
      },
      {
        name: "Executives - Fach- und Führungskräfte",
        route: "executives",
      },
      {
        name: "representatives - Meinungsführer und Influencer",
        route: "representatives",
      },
    ],
    cartItems: ["ids:"],
    formtype: null,
    varCandidates: [
      {
        ambition: "",
        isOpen: false,
        addtoCart: false,
        carerix_id: "",
      },
    ],
    // window: {
    //   width: 0,
    //   height: 0
    // }
  }),
  computed: {
    ...mapState({
      candidates: (state) => state.candidates.candidates,
      cart: (state) => state.cart.cart,
    }),
  },
  created() {
    this.$router.beforeEach((to, from, next) => {
      this.hideMenu();
      next();
    });
  },
  mounted() {
    this.$store.dispatch("cart/getCart");
    if (localStorage.getItem("varCandidates")) {
      this.varCandidates = JSON.parse(localStorage.getItem("varCandidates"));
    }
    this.$store.dispatch("candidates/getCandidates");
    this.$store.dispatch("publications/getPublications");
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    hideMenu() {
      this.menuVisible = false;
    },
    closeTest() {
      this.showTest = false;
    },
    closeCart() {
      this.showCart = false;
    },
    closeDialog() {
      this.showDialog = false;
    },
    userSavedSnackbar() {
      this.userSaved = true;
    },
    messageSentSnackbar() {
      this.messageSent = true;
    },
    ...mapActions("candidates", [
      "addCandidate",
      "getCandidates",
      "deleteCandidate",
    ]),
    getCartItems() {
      for (var i in this.varCandidates) {
        var item = this.varCandidates[i];
        if (item.addtoCart) {
          this.cartItems.push(item.carerix_id);
        }
      }
      return this.cartItems;
    },
    getCartItemsStore() {
      for (var i in this.$store.state.cart.cart) {
        var item = this.$store.state.cart.cart[i];
        if (item.addtoCart) {
          this.cartItems.push(item.carerix_id);
        }
      }
      return this.cartItems;
    },
    getCartItemsSimple() {
      this.cartItems.push("item");
    },
    emptyCart() {
      for (var i in this.$store.state.cart.cart) {
        var item = this.$store.state.cart.cart[i];
        if (item.addtoCart) {
          this.removeFromCart(item.carerix_id);
        }
      }
      return this.cartItems;
    },
    getCartAmount() {
      return this.$store.state.cart.cart.filter((obj) => {
        return obj.addtoCart === true;
      }).length;
    },
    getImg(name) {
      return require("./assets/" + name);
    },
    removeFromCart(value) {
      if (localStorage.getItem("varCandidates")) {
        this.varCandidates = JSON.parse(localStorage.getItem("varCandidates"));
      }
      // const item = this.$store.state.cart.cart.filter(obj => {
      const item = this.varCandidates.filter((obj) => {
        return obj.carerix_id === value;
      })[0];
      if (typeof item !== "undefined") {
        item.addtoCart = !item.addtoCart;
      }
    },
    getSvg(name) {
      return require("./assets/media/" + name + ".svg");
    },
  },
  watch: {
    varCandidates: {
      handler() {
        localStorage.setItem(
          "varCandidates",
          JSON.stringify(this.varCandidates)
        );
        this.$store.dispatch("cart/getCart");
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
@import "./assets/css/shared.scss";
#app {
  font-family: "Merriweather", serif;
  text-align: center;
  color: $primary-font;
}

.top-item {
  margin-top: 13px;
}

// .md-scrollbar.md-theme-default::-webkit-scrollbar-thumb {
//     background: #0b233e;
// }

@media (min-height: 300px) and (max-height: 700px) {
  .top-item {
    margin-top: -23px;
  }
}

.md-drawer.md-active {
  transform: translate3D(0, 0, 0);
  // transition-timing-function: cubic-bezier(.4,0,.2,1);
}
.md-drawer {
  width: 250px !important;
  max-width: calc(100vw - 125px) !important;
  border-right: 1px solid white;
  background-color: $dark-background !important;
  color: white;
  transition: transform 0.2s cubic-bezier(0.15, 0.5, 0.25, 1) !important;
  transition-property: transform;
  transition-duration: 0.2s;
  transition-timing-function: cubic-bezier(0.15, 0.5, 0.25, 1);
  transition-delay: 0s;
}
.md-content {
  padding: 0px !important;
}
.experts {
  background-color: $fourth-color;
  color: $primary-font;
  height: 80px !important;
}
.executives {
  background-color: $fourth-color;
  color: $primary-font;
  height: 80px !important;
}
.representatives {
  background-color: $fourth-color;
  color: $primary-font;
  height: 80px !important;
}
.cta-intro {
  .md-list-item-content {
    min-height: 80px !important;
  }
  h2 {
    color: $primary-font;
    font-weight: 600;
    line-height: 130% !important;
  }
}
.cta-button {
  .md-list-item-content {
    min-height: 80px !important;
  }
}
.md-list-item-content {
  min-height: 28px !important;
  background-color: $dark-background;
}
.md-list.md-theme-default {
  background-color: $dark-background !important;
  color: rgb(255, 255, 255) !important;
}

.md-card.md-theme-default.md-primary {
  h2 {
    color: #fff;
    color: var(--md-theme-default-text-primary-on-primary, #fff);
  }
}
.full-height {
  height: 100vh;
}

.header-cta {
  position: absolute;
  right: 40px;
  top: 10px;
  color: $highlighter-blue;
  a {
    color: $highlighter-blue;
  }
}
.md-card-side-nav {
  width: 100% !important;
  background-color: #f5f5f5;
  .md-card-header {
    padding: 5px !important;
  }
  .md-title {
    font-size: 20px !important;
    line-height: 26px !important;
  }
}
.md-card-side-nav:hover {
  background-color: #ced0fd;
  .new-profiles {
    color: $highlighter-green;
  }
}
.new-profiles {
  font-size: 10px;
  color: $highlighter-blue;
}

.tool {
  .md-menu-content-container .md-list {
    padding: 0;
  }
}

.md-progress-bar {
  position: absolute !important;
  top: 0;
  right: 0;
  left: 0;
}

.md-field.md-theme-default.checkbox:after {
  background-color: rgba(0, 0, 0, 0) !important;
}

.md-field.checkbox label {
  top: 0px !important;
}

.header-team {
  background-color: $dark-background;
  margin: 15px;
  border-radius: 5px;
  padding: 10px;
  .md-title {
    color: $secondary-color;
  }
  span {
    color: $secondary-color;
  }
}

.md-list-item-text {
  position: relative;
  h3 {
    color: #f5f5f5;
  }
  h3:hover {
    color: $highlighter-blue;
    background: $secondary-color;
  }
}

.md-list-item-text-after {
  color: #f5f5f5 !important;
  position: absolute;
  left: 90px;
}
.md-list-item-text-after:hover {
  color: #f5f5f5 !important;
}
.md-list-item-text-after-form {
  color: #f5f5f5 !important;
  position: absolute;
  left: 160px;
}
.md-list-item-text-after-form:hover {
  color: #f5f5f5 !important;
}

.side-imp {
  position: absolute;
  bottom: 40px;
  left: 15px;
  color: $secondary-color;
  a {
    font-size: 0.8rem;
    color: $logo-blue !important;
  }
}
.side-nan {
  position: absolute;
  bottom: 22px;
  left: 15px;
  a {
    font-size: 0.65rem;
    color: $secondary-color !important;
  }
}
.side-copy {
  position: absolute;
  bottom: 5px;
  left: 15px;
  a {
    font-size: 0.65rem;
    color: $secondary-color !important;
  }
}

.icons {
  position: absolute;
  bottom: 60px;
  left: 15px;
  margin: 0px;
}

.md-toolbar.md-theme-default {
  margin: 0px !important;
  padding: 0px !important;
  max-width: 100vw;
}

.cartadd {
  background-color: $dark-background !important;
  .md-button-content {
    color: $secondary-color !important;
  }
}

.md-dialog {
  max-height: 100% !important;
  min-width: 50% !important;
  display: block !important;
}

@media (max-width: 599px) {
  .new-profiles {
    font-size: 8px;
    margin-left: -4px;
  }
  h3 {
    font-size: 11px;
  }
  .md-list-item-content {
    padding: 3px 11px !important;
  }
}

.md-theme-default a:not(.md-button) {
  color: white;
}
</style>
